import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const stripeKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'stripe'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'stripe', itemId] as const,
        detail: [...keys, 'stripe', itemId, 'detail'] as const,
      }),
  });

export { stripeKeys };
